module.exports = __webpack_public_path__ + "static/media/family_18.6f282c46.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/family/JPEG/family_18.jpg
// module id = 5849
// module chunks = 0